import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { TGuestListApiResponse } from '../../../../apis/users/users.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getGuestListKey = 'get-guest-list';

export const useGuestListHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<TGuestListApiResponse, TQueryError>
): UseQueryResult<TGuestListApiResponse, TQueryError> => {
  const { getGuestList } = useUsersService();

  const queryKey = [getGuestListKey, params];

  return useQuery<TGuestListApiResponse, TQueryError>({
    queryKey,
    queryFn: () => getGuestList(params),
    enabled: true,
    ...options,
  });
};
